import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { DialogRef } from '@/shared/dialog/dialog-ref'

@Component
export default class Dialog<T> extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly dialogRef!: DialogRef<T>

  public close(): void {
    this.dialogRef.close()
  }

  public dismiss(): void {
    this.dialogRef.dismiss()
  }
}
